import axiosInstance from './axiosInstance';

// Support desk. Anybody with a login can raise a ticket; answering needs SupportDesk,
// which the API checks on every call — the menu only decides what is offered.

export const raiseTicket = (payload) => axiosInstance.post('/Support/Raise', payload);
export const getMyTickets = () => axiosInstance.get('/Support/GetMine');

export const getAllTickets = ({ status, category, assignedTo } = {}) => {
    const qs = new URLSearchParams();
    if (status) qs.append('status', status);
    if (category) qs.append('category', category);
    if (assignedTo) qs.append('assignedTo', assignedTo);
    const q = qs.toString();
    return axiosInstance.get(`/Support/GetAll${q ? `?${q}` : ''}`);
};

export const getTicket = (supportTicketId) =>
    axiosInstance.get(`/Support/GetById?supportTicketId=${supportTicketId}`);

export const replyTicket = ({ supportTicketId, body, attachments, isInternalNote }) =>
    axiosInstance.post('/Support/Reply', { supportTicketId, body, attachments, isInternalNote });

// Desk only: status, priority, category, assignment.
export const updateTicket = (payload) => axiosInstance.post('/Support/Update', payload);

// The person who asked says when it is solved — not the desk.
export const markResolved = (supportTicketId) =>
    axiosInstance.post(`/Support/MarkResolved?supportTicketId=${supportTicketId}`);

export const getSupportCounts = () => axiosInstance.get('/Support/Counts');

// Sales this person may attach a ticket to, by customer name, phone or sales id. The
// API scopes it: the desk searches everything, anybody else only their own sales.
export const findSalesForTicket = (q) =>
    axiosInstance.get('/Support/FindSales', { params: { q } });
